import { Button, TableCell, TableRow } from "@mui/material";
import { entryTableRowStyle } from "../../../style/salesRecordCollectiveEntryStyle";
import EntryProduct from "./EntryProduct";
import EntryDetailRow from "./EntryDetailRow";
import SALES_RECORD_TYPE from "../../../../../../utils/variable";
import { isPastDate } from "../../../../../../utils/utils";

const rowStyle = entryTableRowStyle;

// 販売原票あたり明細最大数
const MAX_DETAILS_NUMBER_PER_SALES_RECORD = 6;

function EntryProductRow({product, control, selectOptions, keyHandler}) {

  const isNewEntry = product.salesRecordNo === null;
  const isPastEntry = !isNewEntry && isPastDate(new Date(product.arrivalDate));
  const isFullDetails = !isNewEntry && product.details.length >= MAX_DETAILS_NUMBER_PER_SALES_RECORD;

  const enabledDeleteDetail = product.details.length > 1;

  const handleClickShowSalesRecord = (_e) => {
    control.showSalesRecord(
      product.salesRecordNo,
      isPastEntry ? SALES_RECORD_TYPE.STOCK : SALES_RECORD_TYPE.TRAVEL
    );
  }

  return (
    <TableRow sx={{backgroundColor: "white"}}>
      <TableCell sx={{...rowStyle.product, verticalAlign: 'top', paddingTop: '32px', px: 1,  backgroundColor: "white"}}>
        <EntryProduct
          product={product}
          changeNeedsPrintForEachDetail={control.changeNeedsPrintForEachDetail(product.productIndex)}
        />
      </TableCell>
      <TableCell sx={{...rowStyle.detail, px: 1}}>
        {    
          product.details.map((detail, dtlIndex) => (
            <EntryDetailRow
              key={`product_detail_row_${dtlIndex}`}
              detail={detail}
              isNewEntry={isNewEntry}
              isPastEntry={isPastEntry}
              isFullDetails={isFullDetails}
              changeValue={control.changeEntryDetailValue(product.productIndex, detail.detailIndex)}
              addDetail={control.addDetail(product.productIndex, detail.detailIndex)}
              deleteDetail={control.deleteDetail(product.productIndex, detail.detailIndex)}
              enabledDelete={enabledDeleteDetail}
              selectOptions={selectOptions}
              keyHandler={keyHandler(dtlIndex)}
            />
          ))
        }
      </TableCell>
      <TableCell
        sx={{...rowStyle.showSalesRecordButton, verticalAlign: 'top', paddingTop: '28px', px: 1}}
      >
        {
          isNewEntry
            ? null
            : (
              <Button variant="outlined" width="100px"
                onClick={handleClickShowSalesRecord}
              >
                販売原票
              </Button>
            )
        }
        
      </TableCell>
    </TableRow>
  );
}



export default EntryProductRow;